import { render, staticRenderFns } from "./NoticeManage.vue?vue&type=template&id=9586c74a&"
import script from "./NoticeManage.vue?vue&type=script&lang=js&"
export * from "./NoticeManage.vue?vue&type=script&lang=js&"
import style0 from "./NoticeManage.vue?vue&type=style&index=0&id=9586c74a&lang=scss&"
import style1 from "./NoticeManage.vue?vue&type=style&index=1&id=9586c74a&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9586c74a')) {
      api.createRecord('9586c74a', component.options)
    } else {
      api.reload('9586c74a', component.options)
    }
    module.hot.accept("./NoticeManage.vue?vue&type=template&id=9586c74a&", function () {
      api.rerender('9586c74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/others/notice-manage/NoticeManage.vue"
export default component.exports